import { useMutation } from '@tanstack/react-query';

import { sendNewPtAddress, sendNewPtAddressCommon } from '../api';

export const useSendNewPtAddress = () => {
  return useMutation({
    mutationKey: 'sendNewPtAddress',
    mutationFn: (params) =>
      params.interfaceCommonYn === 'Y' ? sendNewPtAddressCommon(params) : sendNewPtAddress(params),
  });
};
